<template>
  <div class="row">
    <div class="col-12">
      <template>
        <component
          :is="component"
          :documentInfo.sync="documentInfo"
        />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'local-exhaust-system-plan-doc',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          title: '',
        }
      },
    },
  },
  data() {
    return {
      editable: true,
      documentInfo: {
        documentClassCd: 'LOVA', // LOCAL_VENTILATION_ATTACH
        title: '국소배기장치 설치계획 문서',
      },
      component: null,
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.component = () => import('@/pages/psi/documentMaster.vue');
      this.documentInfo.title = this.$comm.getLangLabel('LBL0010568'); // 국소배기장치 설치계획 문서
    },
    reset() {
      Object.assign(this.$data.documentInfo, this.$options.data().documentInfo);
    },
  }
};
</script>